import { useState } from "react";
import { MotionBox as Box, fade } from "utils/motion";

const arrowStyle = {
  width: "42px",
  height: "42px",
  position: "absolute",
  cursor: "pointer",
};

const spring = (left) => ({
  hidden: {
    x: left ? -100 : 100,
    translateY: left ? -36 : -42,
    rotate: left ? "180deg" : "0deg",
  },
  visible: { x: 0, transition: { type: "spring", stiffness: 76, damping: 16 } },
});

export default function HorizontalSliderArrow({
  left,
  right,
  visible,
  onClick,
}) {
  const [hovering, setHovering] = useState(false);

  return (
    <>
      <Box
        top="50%"
        left={left ? 6 : null}
        right={right ? 6 : null}
        display={["none", null, "block"]}
        onClick={onClick}
        onHoverStart={() => setHovering(true)}
        onHoverEnd={() => setHovering(false)}
        style={arrowStyle}
        variants={spring(left)}
        initial="hidden"
        animate={visible ? "visible" : "hidden"}
      >
        <Box
          variants={fade}
          initial="hidden"
          animate={hovering ? "visible" : "hidden"}
        >
          <ArrowIconHovered />
        </Box>
        <Box
          variants={fade}
          initial="normal"
          animate={hovering ? "hidden" : "visible"}
        >
          <ArrowIcon />
        </Box>
      </Box>
      <Box
        top="95%"
        left={left ? ["35%", "44%"] : null}
        right={right ? ["35%", "40%", null] : null}
        display={["block", null, "none"]}
        onClick={onClick}
        style={{
          transform: left
            ? "translateY(-36px) rotate(180deg)"
            : "translateY(-42px) rotate(0deg)",
          ...arrowStyle,
        }}
      >
        <ArrowIcon />
      </Box>
    </>
  );
}

const ArrowIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} {...props}>
    <defs>
      <filter
        id="a"
        width="141.7%"
        height="141.7%"
        x="-20.8%"
        y="-16.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={4}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g fill="#FFF" fillRule="evenodd" filter="url(#a)">
      <path
        d="M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21A21 21 0 0 0 24 3z"
        opacity={0.5}
      />
      <path d="m21.18 13.935-2.115 2.13L27 24l-7.935 7.935 2.115 2.13 7.935-7.95a3 3 0 0 0 0-4.23l-7.935-7.95z" />
    </g>
  </svg>
);

const ArrowIconHovered = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 0 48 48"
    style={{ position: "absolute" }}
    {...props}
  >
    <defs>
      <filter id="prefix__a" colorInterpolationFilters="auto">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter
        id="prefix__b"
        width="183.3%"
        height="183.3%"
        x="-41.7%"
        y="-41.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      filter="url(#prefix__a)"
      transform="translate(-2025 -392)"
      fill="none"
      fillRule="evenodd"
    >
      <g filter="url(#prefix__b)" transform="translate(2025 392)">
        <path
          fill="#FFF"
          d="M24 3c5.57 0 10.911 2.212 14.85 6.15A21.009 21.009 0 0145 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3zm-2.82 10.935l-2.115 2.13L27 24l-7.935 7.935 2.115 2.13 7.935-7.95a3 3 0 000-4.23l-7.935-7.95z"
        />
      </g>
    </g>
  </svg>
);
